require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./work-salisbury-bid.json") })
        }
      }, "path---work-salisbury-bid");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---work-salisbury-bid!./.cache/json/work-salisbury-bid.json
// module id = 1532
// module chunks = 231608221292675